"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayerPreviousFrame = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var PlayerPreviousFrame = function PlayerPreviousFrame(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.0156 6.03125C14.2344 6.03125 16.125 6.8125 17.6875 8.375C19.25 9.9375 20.0312 11.8125 20.0312 14C20.0312 16.2188 19.2344 18.1094 17.6406 19.6719C16.0781 21.2344 14.2031 22.0156 12.0156 22.0156C9.82812 22.0156 7.9375 21.2344 6.34375 19.6719C4.78125 18.1094 4 16.2188 4 14H6.01562C6.01562 15.6562 6.59375 17.0781 7.75 18.2656C8.9375 19.4219 10.3594 20 12.0156 20C13.6719 20 15.0781 19.4219 16.2344 18.2656C17.4219 17.0781 18.0156 15.6562 18.0156 14C18.0156 12.3438 17.4219 10.9375 16.2344 9.78125C15.0781 8.59375 13.6719 8 12.0156 8V12.0312L7 7.01562L12.0156 2V6.03125Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.7285 17.0156H11.7383V13.8633L10.7656 14.1475V13.3975L12.6377 12.75H12.7285V17.0156Z"
  }));
};
exports.PlayerPreviousFrame = PlayerPreviousFrame;